<template>
  <div class="companies">
    <div class="box">
      <div class="case">
        <div class="advanced_search">
          <div class="carousel" style="">
            <img
              src="../../../assets/imgs/素材/棕黄色logo.png"
              style="width: 50px"
              alt=""
            />
          </div>
          <div style="margin: 0 0 0 12px; width: 79%">
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
              "
            >
              <div style="width: 100%; display: flex; position: relative">
                <el-input
                  placeholder="请输入检索内容，重新检索"
                  v-model="input"
                  class="input-with-select tit_input"
                  @keyup.enter.native="newSearch_"
                  clearable
                >
                  <el-select
                    v-model="select"
                    slot="prepend"
                    placeholder="请选择"
                    style="width: 150px"
                    class="titSelect"
                  >
                    <el-option
                      label="公司名称"
                      value="company_name"
                      style="text-align: center"
                    ></el-option>
                    <el-option
                      label="法定代表人"
                      value="legal_person"
                      style="text-align: center"
                    ></el-option>
                    <el-option
                      label="社会信用代码"
                      value="usco"
                      style="text-align: center"
                    ></el-option>
                  </el-select>
                </el-input>

                <el-button
                  type="warning"
                  @click="newSearch_"
                  style="width: 80px"
                  class="search_button"
                  >检索</el-button
                >
              </div>

              <el-popover
                placement="bottom-end"
                trigger="click"
                v-model="visible"
              >
                <el-form
                  ref="form"
                  :model="form"
                  label-width="100px"
                  style="padding: 20px 20px 0 20px !important"
                >
                  <el-form-item label="法定代表人: ">
                    <div
                      class="add_s"
                      v-for="(item, index) in legal_person_s"
                      :key="index"
                    >
                      <el-input
                        placeholder="请输入法定代表人"
                        v-model="item.name"
                      ></el-input>
                      <el-button
                        style="margin: 0 10px"
                        type="text"
                        @click="add_s('legal_person', index)"
                        icon="el-icon-circle-plus"
                        circle
                      ></el-button>

                      <el-button
                        :disabled="legal_person_s.length <= 1"
                        style=""
                        type="text"
                        @click="del_s('legal_person', index)"
                        icon="el-icon-remove"
                        circle
                      ></el-button>
                    </div>
                  </el-form-item>
                  <el-form-item label="经营范围:">
                    <el-input
                      placeholder="请输入经营范围"
                      v-model="condition.business"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="地区: ">
                    <!-- <el-cascader
                      v-model="form.region"
                      :options="courtData"
                      clearable
                      :props="{
                        value: 'code',
                        label: 'name',
                        children: 'children',
                        checkStrictly: true,
                      }"
                      filterable
                    ></el-cascader> -->
                    <el-cascader
                      class="sel"
                      style="width: calc(45% + 90px)"
                      v-model="condition.region"
                      :options="criteria_copy.courtData"
                      clearable
                      :props="{
                        value: 'code',
                        label: 'name',
                        children: 'children',
                        multiple: true,
                        checkStrictly: true,
                      }"
                      filterable
                      popper-class="train-tree"
                    >
                    </el-cascader>
                  </el-form-item>
                  <el-form-item label="注册资本: ">
                    <div style="display: flex">
                      <el-checkbox-group v-model="condition.capital">
                        <el-checkbox
                          v-for="(item, index) in criteria_copy.capital_s"
                          :key="index"
                          :label="item.from_to"
                          >{{ item.key }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <el-popover
                        placement="bottom"
                        trigger="click"
                        v-model="visible_cap"
                      >
                        <span>注册资本 :&emsp;</span>
                        <el-input
                          style="width: 100px"
                          size="small"
                          v-model="self_cap.from"
                          clearable
                          placeholder="请输入"
                        ></el-input>
                        <span>&ensp;--&ensp;</span>
                        <el-input
                          style="width: 100px"
                          size="small"
                          v-model="self_cap.to"
                          clearable
                          placeholder="请输入"
                        ></el-input
                        >&ensp;万
                        <!-- <div style="text-align: right;margin: 10px 0 0 0;">
                          <el-button type="primary"  size="mini">确定</el-button>
                        </div> -->
                        <el-button
                          style="margin: 0 0 0 30px"
                          type="text"
                          slot="reference"
                          :style="
                            self_cap.from !== '' && self_cap.to !== ''
                              ? ''
                              : 'color: #000000;'
                          "
                          >自定义 <i class="el-icon-caret-bottom"></i
                        ></el-button>
                      </el-popover>
                    </div>
                  </el-form-item>
                  <el-form-item label="成立年限: ">
                    <div style="display: flex">
                      <el-checkbox-group v-model="condition.start_date">
                        <el-checkbox
                          v-for="(item, index) in criteria_copy.timeData"
                          :key="index"
                          :label="item.from_to_string"
                          >{{ item.key }}</el-checkbox
                        >
                      </el-checkbox-group>
                      <el-popover
                        placement="bottom"
                        trigger="click"
                        v-model="visible_time"
                      >
                        <span>成立年限 :&emsp;</span>
                        <el-date-picker
                          v-model="self_time"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy 年 MM 月 dd 日"
                          value-format="yyyy-MM-dd"
                          @input="handleDate"
                        >
                        </el-date-picker>
                        <el-button
                          style="margin: 0 0 0 30px"
                          :style="
                            self_time.length > 0 && self_time !== null
                              ? ''
                              : 'color: #000000;'
                          "
                          type="text"
                          slot="reference"
                          >自定义 <i class="el-icon-caret-bottom"></i
                        ></el-button>
                      </el-popover>
                    </div>
                  </el-form-item>
                  <el-form-item label="企业状态: ">
                    <el-checkbox-group v-model="condition.status">
                      <el-checkbox
                        v-for="(item, index) in criteria_copy.status_"
                        :key="index"
                        :label="item"
                        >{{ item }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="资本类型: ">
                    <!-- <el-checkbox-group v-model="form.unit">
                      <el-checkbox
                        v-for="(item, index) in capital_types"
                        :key="index"
                        :label="item.label"
                        >{{ item.key }}</el-checkbox
                      >
                    </el-checkbox-group> -->
                    <el-radio-group v-model="condition.unit">
                      <el-radio
                        v-for="(item, index) in capital_types"
                        :key="index"
                        :label="item.label"
                        >{{ item.key }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item style="text-align: right; margin: 0px">
                    <el-button type="primary" size="small" @click="seniorCase"
                      >搜 索</el-button
                    >
                  </el-form-item>
                </el-form>
                <el-button
                  slot="reference"
                  type="warning"
                  style="margin: 0 0 0 20px"
                  >高级检索 >></el-button
                >
              </el-popover>
            </div>
            <div class="conditions">
              <div class="condition">
                <span style="position: absolute">搜索条件</span>
                <span class="eltags">
                  <div v-for="(val, key, index) in form" :key="index">
                    <!-- form[key].constructor === Array -->
                    <el-tag
                      v-if="form[key] !== '' && form[key].length > 0"
                      :closable="tag_closable > 1"
                      type="warning"
                      @close="handleClose(key, index)"
                    >
                      <span v-if="key == 'legal_person'">法定代表人：</span>
                      <span v-if="key == 'usco'">统一社会信用代码：</span>
                      <span v-if="key == 'company_name'">公司名：</span>
                      <span v-if="key == 'region'">地区：</span>
                      <span v-if="key == 'business'">经营范围：</span>
                      <span v-if="key == 'status'">经营状态：</span>

                      <span v-if="key == 'start_date'">成立日期：</span>
                      <span v-if="key == 'capital'">注册资金：</span>
                      <span v-if="key == 'unit'">资本类型：</span>
                      <span
                        v-if="
                          form[key].constructor === Array &&
                          form[key].length > 1
                        "
                        class="word_tag"
                      >
                        <!-- <span> -->
                        <el-tag
                          closable
                          size="mini"
                          v-for="(item, i) in form[key]"
                          :key="i"
                          @close="handleClose_one(key, i)"
                        >
                          <span
                            v-if="
                              key == 'region' ||
                              key == 'status' ||
                              key == 'legal_person'
                            "
                            >{{ item.replace(/[0-9]/g, "") }}</span
                          >
                          <span v-if="key == 'start_date'">
                            <span
                              v-if="item[0] == null || item[0] == undefined"
                              >{{ " > " + item[1] }}</span
                            >
                            <!-- <span v-if="item[1] ==null || item[1]==undefined">{{">"+item[0]}}</span> -->
                            <span v-else>{{ item[0] }} -- {{ item[1] }}</span>
                          </span>
                          <span v-if="key == 'capital'">
                            <!-- {{(item[0] ==null||item[0]==undefined)?0:item[0]}} - {{item[0]}} -->
                            <span
                              v-if="item[0] == null || item[0] == undefined"
                              >{{ " 0 -" + item[1] }}</span
                            >
                            <span
                              v-if="item[1] == null || item[1] == undefined"
                              >{{ " > " + item[0] }}</span
                            >
                            <span v-else>{{ item[0] }} -- {{ item[1] }}</span>
                            万
                          </span>
                        </el-tag>
                        <!-- </span> -->
                      </span>
                      <span v-else>
                        <span v-if="form[key].constructor === Array">
                          <span v-if="val[0].constructor === Array"
                            >{{ val[0][0] }} -- {{ val[0][1] }}
                            <span v-if="key == 'capital'"> 万</span></span
                          >
                          <span v-else>
                            <span v-if="key == 'region'">{{
                              val[0].replace(/[0-9]/g, "")
                            }}</span>
                            <span v-else>{{ val[0] }}</span>
                          </span>
                        </span>
                        <span v-else>{{ val }}</span>
                      </span>
                    </el-tag>
                  </div>
                </span>
              </div>
              <div class="savebtn">
                <i class="el-icon-delete" @click="remove">重新检索</i>
              </div>
            </div>
          </div>
        </div>
        <div class="box_botton">
          <div class="box_left" v-if="show_">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              :default-openeds="openeds"
            >
              <el-submenu index="0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2(1).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px">地区</span>
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="moreall ? courtData : courtData.slice(0, 10)"
                    :props="court"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    accordion
                    :expand-on-click-node="false"
                    @node-click="regionClick"
                    :default-expand-all="defaultall"
                    class="region cityClass"
                    style="padding-left: 20px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(data.name) ? 'color: #e6a23c;' : ''
                      "
                      slot-scope="{ data }"
                    >
                      <span style="padding-bottom: 10px !import"
                        ><span style="font-weight: 900 !important">{{
                          data.name
                        }}</span>
                        ({{ data.doc_count }})
                      </span>
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    v-if="courtData.length > 10"
                    @click="more"
                    v-show="moreShow"
                    class="more"
                    style=""
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="1">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/00.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >经营状态</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="refData"
                    :props="ref"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="refClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="char_.includes(data.key) ? 'color: #e6a23c;' : ''"
                      slot-scope="{ data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                </div>
              </el-submenu>
              <el-submenu index="2">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >注册资本</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    :data="capitalAll ? capital_s : capital_s.slice(0, 10)"
                    :props="time"
                    @node-click="capitalClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(JSON.stringify(data.from_to))
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="timeData.length > 10"
                    @click="times"
                    v-show="timeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >成立日期</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    :data="timeall ? timeData : timeData.slice(0, 10)"
                    :props="time"
                    @node-click="timeClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(JSON.stringify(data.from_to_string))
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                      <!-- <span></span> -->
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="timeData.length > 10"
                    @click="times"
                    v-show="timeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <div class="box_right">
            <div class="box_right_top">
              <div>
                <span style="margin-right: 20px"
                  >共<span style="color: #cf8700">{{ totalCount }}</span
                  >篇</span
                >
              </div>

              <div>
                <span style="margin-right: 10px">排序方式</span>
                <el-select
                  v-model="value_sort.type"
                  placeholder="请选择"
                  size="mini"
                  style="width: 110px"
                  class="bac"
                >
                  <el-option
                    v-for="item in defaultsort"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span @click="itemsort(item.value)">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div
              class="box_main"
              v-loading="loading_box"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px"
              element-loading-background="rgba(255, 255, 255, 0.5)"
            >
              <div
                v-if="exampleList.length <= 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 500px;
                "
              >
                <div>
                  <img src="../Case/kongkong.png" alt="" />
                  <div style="text-align: center; font-size: 20px">
                    暂无数据
                  </div>
                </div>
              </div>
              <div
                class="box_main_list"
                v-for="(item, index) in exampleList"
                :key="index"
              >
                <div class="title">
                  <router-link
                    :to="{
                      path: `/companiesDetails/${item.id}`,
                      query: { form: JSON.stringify(form) },
                    }"
                    target="_blank"
                  >
                    <h2
                      style="
                        display: inline-block;
                        font-weight: 900;
                        font-size: 18px;
                      "
                      v-html="item.com_name"
                    ></h2>
                  </router-link>
                  <div style="" class="collDown" v-if="item.status !== null">
                    <el-tag class="list_tag" type="warning">{{
                      item.status.substring(0, 2)
                    }}</el-tag>
                    <el-tag
                      v-if="item.count > 0"
                      class="list_tag"
                      type="warning"
                    >
                      <span v-if="item.count <= 999">{{ item.count }}</span>
                      <span v-else>999+</span>
                    </el-tag>
                  </div>
                </div>
                <div class="collection_icon">
                  <div class="collection" v-if="item.coll == 0">
                    <el-tooltip content="关注" placement="left" effect="light">
                      <img
                        @click="collectible(item)"
                        src="../../../assets/imgs/2.0/_收藏.png"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                  <div class="collection" v-if="item.coll == 1">
                    <!-- <el-tooltip content="收藏" placement="left" effect="light">
                      <img
                        v-if="true"
                        @click="collectible(item)"
                        src="../../../assets/imgs/2.0/_收藏.png"
                        alt=""
                      />
                    </el-tooltip> -->
                    <el-popconfirm
                      title="确认取消关注吗？"
                      @confirm="cancel(item)"
                    >
                      <img
                        slot="reference"
                        src="../../../assets/imgs/2.0/收藏3.png"
                        alt=""
                      />
                    </el-popconfirm>
                  </div>
                </div>
                <div class="box_detail">
                  <div class="basic">
                    <div class="basic_right">
                      <div
                        style="
                          font-size: 14px;
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <div class="basic_content">
                          <div>
                            法人姓名：<span
                              v-if="item.legal_person"
                              v-html="item.legal_person"
                              style="width: 200px; display: inline"
                            >
                            </span>
                          </div>
                          <div>
                            统一社会信用代码：<span
                              v-if="item.USCO"
                              v-html="item.USCO"
                            ></span>
                          </div>
                        </div>
                        <div class="basic_content">
                          <div>
                            成立日期：<span
                              v-if="item.start_date"
                              v-html="item.start_date"
                            ></span>
                          </div>
                          <div>
                            地址：<span
                              v-if="item.address"
                              v-html="item.address"
                            ></span>
                          </div>
                        </div>
                      </div>
                      <p
                        class="key_txt"
                        style="font-size: 14px; line-height: 30px"
                      >
                        <span class="key_tit">经营范围：</span>
                        <span
                          class="key_box"
                          v-if="item.nature_of_business !== null"
                        >
                          <span v-if="index_more !== index">
                            {{ item.nature_of_business.slice(0, 121)
                            }}<span v-if="item.nature_of_business.length > 120"
                              >...</span
                            >
                            <span
                              style="
                                font-weight: 500;
                                color: #409eff;
                                cursor: pointer;
                              "
                              v-if="item.nature_of_business.length > 120"
                              @click="index_more = index"
                            >
                              &ensp;更多</span
                            >
                          </span>
                          <span v-else>
                            {{ item.nature_of_business }}
                            <span
                              style="
                                font-weight: 500;
                                color: #409eff;
                                cursor: pointer;
                              "
                              @click="index_more = ''"
                            >
                              &ensp;收起</span
                            >
                          </span>
                        </span>
                      </p>
                      <p
                        class="key_txt"
                        style="
                          font-size: 14px;
                          line-height: 30px;
                          margin: 10px 0 0 0;
                        "
                        v-if="item.aggsres.length > 0"
                      >
                        <span
                          class="key_tit"
                          style="
                            line-height: 40px;
                            font-weight: 900;
                            letter-spacing: 2px;
                          "
                          >主要案件案由：</span
                        >
                        <span class="key_box">
                          <el-tag
                            style="margin: 0 10px"
                            type="warning"
                            v-for="(item_tag, index_tag) in item.aggsres"
                            :key="index_tag"
                          >
                            {{ item_tag.key.replace(/[0-9]/g, "") }}
                          </el-tag>
                        </span>
                      </p>
                    </div>
                  </div>

                  <!-- <div>分数：{{ item._score }}</div> -->
                </div>
              </div>
            </div>
            <div class="page-bar" v-if="totalCount > 9">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalCount > 10000 ? 10000 : totalCount"
                @current-change="handleCurrentChange"
                :current-page.sync="companies_field.page"
                :page-size="10"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import ComFooter from "../../../components/ComFooter.vue";
import store from "@/store";
export default {
  data() {
    return {
      input: "",
      select: "company_name",
      totalCount: 0,
      value_sort: { field: "start_date", type: "desc" },
      defaultsort: [
        // {
        //   value: "desc",
        //   label: "案件数量 ↓",
        // },
        // {
        //   value: "asc",
        //   label: "案件数量 ↑",
        // },
        {
          value: "",
          label: "相关度",
        },
        {
          value: "desc",
          label: "成立日期 ↓",
        },
        {
          value: "asc",
          label: "成立日期 ↑",
        },
      ],
      loading_box: false,
      exampleList: [],
      companies_field: {
        company_name: "", //公司名
        usco: "", //统一社会信用代码
        legal_person: "", //法定代表人
        region: "", //地区
        business: "", //经营范围

        status: "", //经营状态 ['在营（开业）','吊销（已注销）']
        start_date: "", //成立日期
        capital: "", //注册资金
        order: JSON.stringify(this.value_sort),
        page: 1,
        size: 10,
        unit: "", //美元| 人民币| 其他
      },
      loadNode: false,
      openeds: ["0", "1", "2", "3"],
      courtData: [],
      defaultall: false,
      moreall: false,
      moreShow: true,
      court: {
        children: "children",
        label: "name",
      },
      refData: [],
      timeData: [],
      ref: {
        children: "children",
        label: "key",
      },
      time: {
        children: "children",
        label: "key",
      },
      timeall: false,
      timeShow: true,
      index_more: "",
      form: {
        legal_person: [],
        business: "",
        region: [],
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      },
      capital_s: [],
      capital_types: [
        {
          label: "人民币",
          key: "人民币",
        },
        {
          label: "美元",
          key: "美元",
        },
        {
          label: "其他",
          key: "其他",
        },
      ],
      status_: [],
      self_time: [],
      self_capital: [],
      self_cap: {
        from: "",
        to: "",
      },
      legal_person_s: [{ name: "" }],
      capitalAll: false,
      capitalShow: true,
      condition: {
        legal_person: [],
        business: "",
        region: "",
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      },
      char_: "",
      commas_left: '"',
      show_: true,
      visible: false,
      visible_cap: false,
      visible_time: false,
      tag_closable: true,
      criteria_copy: {},
    };
  },
  created() {
    if (window.sessionStorage.getItem("enterprise_search")) {
      this.char_ = window.sessionStorage.getItem("enterprise_search");
      this.form = JSON.parse(
        window.sessionStorage.getItem("enterprise_search")
      );
    }
    if (window.sessionStorage.getItem("parameter_criteria")) {
      this.criteria_copy = JSON.parse(
        window.sessionStorage.getItem("parameter_criteria")
      );
    } else {
      this.item_copy();
    }

    if (
      this.form.company_name !== "" ||
      this.form.business !== "" ||
      this.form.legal_person.length > 0
    ) {
      // ||this.form.usco !==''
      this.value_sort = {
        field: "",
        type: "",
      };
    } else {
      this.value_sort = {
        field: "start_date",
        type: "desc",
      };
    }
    this.newSearch();
    // this.region();
  },
  methods: {
    item_copy() {
      let field = {
        company_name: "", //公司名
        usco: "", //统一社会信用代码
        legal_person: "", //法定代表人
        region: "", //地区
        business: "", //经营范围

        status: "", //经营状态 ['在营（开业）','吊销（已注销）']
        start_date: "", //成立日期
        capital: "", //注册资金
        order: '{ field: "", type: "desc_" }',
        page: 1,
        size: 10,
        unit: "", //美元| 人民币| 其他
      };
      this.$http
        .post("/com_category", field)
        .then((res) => {
          // console.log("category--", res);
          // this.loadNode = false;
          let refData_ = [];
          res.data.data.status.forEach((item, index) => {
            if (item.doc_count > 0) {
              refData_.push(item);
            }
          });
          let timeData_ = [];
          res.data.data.start_time.forEach((item, index) => {
            item.from_to_string = [item.from_as_string, item.to_as_string];

            if (item.doc_count > 0) {
              timeData_.push(item);
            }
          });

          let capital_s_ = [];
          res.data.data.capital.forEach((item, index) => {
            item.from_to = [item.from, item.to];
            if (item.doc_count > 0) {
              capital_s_.push(item);
            }
          });
          let courtData_ = res.data.data.region;
          // this.courtData.forEach((item, index) => {
          //   item.code = item.code + item.name;
          // });
          let status__ = [];
          
          refData_.forEach((item, index) => {
            
            if (item.children) {
              item.children.forEach((item_, index_) => {
                status__.push(item_.key);
              });
            }else{
              status__.push(item.key);
            }
          });

          this.criteria_copy = {
            refData: refData_,
            timeData: timeData_,
            capital_s: capital_s_,
            courtData: courtData_,
            status_: status__,
          };
          console.log(this.criteria_copy.status_)
          window.sessionStorage.setItem(
            "parameter_criteria",
            JSON.stringify(this.criteria_copy)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }, // 高检添加
    add_s(type, i) {
      this.legal_person_s.splice(i + 1, 0, { name: "" });
    },
    // 高检删除
    del_s(type, i) {
      this.legal_person_s.splice(i, 1);
    },
    handleDate(value) {
      if (value == null) {
        this.self_time = [];
      }
    },
    // 查看更多
    times() {},
    handleCurrentChange(val) {
      this.companies_field.page = val;
      // this.current_page = val;
      // this.loading_box = true;
      this.newSearch();
      window.scrollTo(0, 0);
    },
    newSearch_() {
      if (this.input !== "") {
        this.self_cap = {
          from: "",
          to: "",
        };
        this.self_time = [];
        this.form = {
          legal_person: [],
          business: "",
          region: [],
          capital: [],
          start_date: [],
          unit: "",
          status: [],
          company_name: "", //公司名
          usco: "", //统一社会信用代码
        };
        if (this.select == "legal_person") {
          this.form.legal_person = [this.input];
        } else {
          this.form[this.select] = this.input;
        }
        this.Flushed();
      } else {
        this.$message({
          message: "请输入检索条件",
          type: "warning",
        });
      }
    },
    // 检索
    newSearch() {
      this.loading_box = true;
      this.loadNode = true;
      this.tag_closable = 0;
      for (var i in this.companies_field) {
        for (var j in this.form) {
          if (i == j) {
            if (this.form[i].constructor === Array) {
              this.companies_field[i] = JSON.stringify(this.form[i]);
            } else {
              this.companies_field[i] = this.form[i];
            }
          }
        }
      }
      for (var i in this.companies_field) {
        if (this.companies_field[i] == "[]") {
          this.companies_field[i] = "";
        }
      }
      for (var i in this.form) {
        for (var j in this.companies_field) {
          if (i == j) {
            if (this.companies_field[i] !== "") {
              this.tag_closable++;
            }
          }
        }
      }
      // console.log(this.companies_field);
      this.companies_field.order = JSON.stringify(this.value_sort);
      this.$http
        .post("/com_search", this.companies_field)
        .then((res) => {
          this.loading_box = false;
          console.log(res);
          this.totalCount = res.data.data.total;
          this.exampleList = res.data.data.data;
          // window.sessionStorage.setItem("parameter", JSON.stringify(parameter));
        })
        .catch((error) => {
          console.log(error);
        });
      this.$http
        .post("/com_category", this.companies_field)
        .then((res) => {
          console.log("category--", res);
          this.loadNode = false;
          this.refData = [];
          res.data.data.status.forEach((item, index) => {
            if (item.doc_count > 0) {
              this.refData.push(item);
            }
          });
          this.timeData = [];
          res.data.data.start_time.forEach((item, index) => {
            item.from_to_string = [item.from_as_string, item.to_as_string];

            if (item.doc_count > 0) {
              this.timeData.push(item);
            }
          });
          // console.log(this.timeData);
          this.capital_s = [];
          res.data.data.capital.forEach((item, index) => {
            item.from_to = [item.from, item.to];
            if (item.doc_count > 0) {
              this.capital_s.push(item);
            }
          });
          this.courtData = res.data.data.region;
          // this.courtData.forEach((item, index) => {
          //   item.code = item.code + item.name;
          // });
          this.status_ = [];
          this.refData.forEach((item, index) => {
            this.status_.push(item.key);
            if (item.children) {
              item.children.forEach((item_, index_) => {
                this.status_.push(item_.key);
              });
            }
          });
          if (!window.sessionStorage.getItem("parameter_criteria")) {
            this.criteria_copy = {
              refData: this.refData,
              timeData: this.timeData,
              capital_s: this.capital_s,
              courtData: this.courtData,
              status_: this.status_,
            };
          }
          // window.sessionStorage.setItem("parameter", JSON.stringify(parameter));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClose(type, index) {
      this.form[type] = "";
      if (this.form[type].constructor === Array) {
        this.form[type] = [];
      } else {
        this.form[type] = "";
      }
      this.Flushed();
    },
    handleClose_one(type, index) {
      this.form[type].splice(index, 1);
      this.Flushed();
    },
    // 地区下拉数据
    region() {
      this.$http
        .get("/province", {})
        .then((res) => {
          this.courtData = res.data.data;
          console.log(this.courtData);
        })
        .catch((err) => {});
    },
    // 高级检索
    seniorCase() {
      // let jump = 0;
      // console.log();
      // for (var i in this.form) {
      //   if (this.form[i].constructor === Array) {
      //     if (this.form[i].length > 0) {
      //       jump++;
      //     }
      //   } else {
      //     if (this.form[i] !== "") {
      //       jump++;
      //     }
      //   }
      // }
      // console.log(jump)
      let form_copy = {
        legal_person: [],
        business: "",
        region: [],
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      };

      this.form = {
        legal_person: [],
        business: "",
        region: [],
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      };
      console.log(this.condition);
      // return
      for (var i in form_copy) {
        for (var j in this.condition) {
          if (i == j) {
            if (i == "region" && this.condition[i].length > 0) {
              this.condition[i].forEach((item, index) => {
                //  console.log(item);
                form_copy[i].push(item[item.length - 1]);
              });
              // console.log('a')
            } else {
              console.log(i);
              // console.log(this.condition.legal_person);
              // if()
              form_copy[i] = this.condition[i];
            }
          }
        }
      }
      console.log(form_copy);
      // return;
      if (this.legal_person_s.length > 0) {
        form_copy.legal_person = [];
        this.legal_person_s.forEach((item, index) => {
          if (item.name !== "") {
            form_copy.legal_person.push(item.name);
          }
        });
      }

      if (this.self_time !== null && this.self_time.length > 0) {
        form_copy.start_date.push(this.self_time);
      }
      if (this.self_cap.from !== null && this.self_cap.to !== "") {
        form_copy.capital.push([this.self_cap.from, this.self_cap.to]);
      }
      //       console.log(form_copy)
      // return
      // console.log(form_copy)
      if (this.Jump_S(form_copy) > 0) {
        this.Jump();
      } else {
        this.$message({
          message: "请添加检索条件",
          type: "warning",
        });
      }
    },
    Jump() {
      for (var i in this.form) {
        for (var j in this.condition) {
          if (i == j) {
            if (i == "region" && this.condition[i].length > 0) {
              this.condition[i].forEach((item, index) => {
                //  console.log(item);
                this.form[i].push(item[item.length - 1]);
              });
            } else {
              this.form[i] = this.condition[i];
            }
          }
        }
      }
      console.log(this.legal_person_s);
      // return;
      if (this.legal_person_s.length > 0) {
        this.legal_person_s.forEach((item, index) => {
          if (item.name !== "") {
            this.form.legal_person.push(item.name);
          }
        });
      }

      // if (this.self_time !== null && this.self_time.length > 0) {
      //   this.form.start_date.push(this.self_time);
      // }
      // if (this.self_cap.from !== null && this.self_cap.to !== "") {
      //   this.form.capital.push([this.self_cap.from, this.self_cap.to]);
      // }
      this.form.company_name = "";
      this.form.usco = "";
      this.input = "";
      console.log(this.form);
      this.visible = false;
      this.visible_cap = false;
      this.visible_time = false;
      this.Flushed();
      this.condition = {
        legal_person: [],
        business: "",
        region: "",
        capital: [],
        start_date: [],
        unit: "",
        status: [],
        company_name: "", //公司名
        usco: "", //统一社会信用代码
      };
    },
    Jump_S(object) {
      let jump = 0;
      console.log();
      for (var i in object) {
        if (object[i].constructor === Array) {
          if (object[i].length > 0) {
            jump++;
          }
        } else {
          if (object[i] !== "") {
            jump++;
          }
        }
      }
      return jump;
      // console.log(jump)
    },
    // 清空条件
    remove() {
      this.$router.push({
        name: "CompaniesHome",
      });
      window.sessionStorage.removeItem("enterprise_search");
    },
    reload_() {
      this.show_ = false;
      this.$nextTick(function () {
        this.show_ = true;
      });
    },
    // 刷选刷新
    Flushed() {
      window.sessionStorage.setItem(
        "enterprise_search",
        JSON.stringify(this.form)
      );
      // this.cur = 1;
      console.log(this.form);
      if (
        this.form.company_name !== "" ||
        this.form.business !== "" ||
        this.form.legal_person.length > 0
      ) {
        // ||this.form.usco !==''
        this.value_sort = {
          field: "",
          type: "",
        };
      } else {
        this.value_sort = {
          field: "start_date",
          type: "desc",
        };
      }
      this.companies_field.page = 1;
      this.reload_();
      this.newSearch();
      this.char_ = window.sessionStorage.getItem("enterprise_search");
    },
    // 地区
    regionClick(data) {
      console.log(this.form.region);
      console.log(data);
      // return
      // this.defaultall = true;
      if (!this.char_.includes(data.code)) {
        // console.log()
        if (this.form.region == "") {
          this.form.region = [];
        }
        this.form.region.push(data.code);
        this.Flushed();
      }
    },
    // 注册资本
    capitalClick(data) {
      // console.log(this.form.capital)
      if (!this.char_.includes(JSON.stringify(data.from_to))) {
        if (this.form.capital == "") {
          this.form.capital = [];
        }
        this.form.capital.push(data.from_to);
        this.Flushed();
      }
    },
    // 查看更多
    more() {
      // console.log("aa");
      this.moreall = true;
      this.moreShow = false;
    },
    // 经营状态
    refClick(data) {
      console.log(this.form);
      if (
        !this.char_.includes(this.commas_left + data.key + this.commas_left)
      ) {
        if (this.form.status == "") {
          this.form.status = [];
        }
        console.log(data);
        if (data.children && data.children.length > 0) {
          
          data.children.forEach((item,index)=>{
           this.form.status.push(item.key);
          })
        } else {
          this.form.status.push(data.key);
        }

        this.Flushed();
      }
    },
    // 成立日期
    timeClick(data) {
      console.log(this.form.start_date);

      if (!this.char_.includes(JSON.stringify(data.from_to_string))) {
        if (this.form.start_date == "") {
          this.form.start_date = [data.from_to_string];
        } else {
          this.form.start_date.push(data.from_to_string);
        }

        this.Flushed();
      }
    },
    // 收藏
    collectible(row) {
      // console.log(row);
      let collOne = {
        // user_id: store.getCookie("user_id"),
        docid: row.id,
        // role: store.getCookie("role"),
        doctype: 4,
        docname: row.com_name,
      };
      this.$http
        .post("/coll", collOne)
        .then((res) => {
          console.log(res);
          this.$message({
            message: "关注成功",
            type: "success",
          });
          this.newSearch();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 取消收藏
    cancel(row) {
      // console.log(row);
      let collOne = {
        docid: row.id,
      };
      this.$http
        .post("/delcoll", collOne)
        .then((res) => {
          console.log(res);
          this.$message({
            message: "取消关注成功",
            type: "success",
          });
          this.newSearch();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 排序
    itemsort(val) {
      console.log(val);
      if (val == "") {
        this.value_sort.field = "";
      } else {
        this.value_sort = {
          field: "start_date",
          type: val,
        };
      }
      this.companies_field.page = 1;
      this.reload_();
      this.newSearch();
    },
  },
  components: {
    ComFooter,
  },
  watch: {
    form: {
      handler(new_value, old_value) {
        // console.log(this.Jump_S(new_value));
        if (this.Jump_S(new_value) <= 0) {
          this.remove();
        }
      },
      deep: true,
    },
  },
};
</script>

<style  lang="less" scoped>
.companies {
  background: rgb(245, 239, 228);
  min-width: 1280px;
  .box {
    width: 100%;
    background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 1000px;
    margin: auto;
    .case {
      width: 1280px;
      min-width: 1280px;
      max-width: 1280px;
      margin: auto;
      min-height: calc(100vh - 60px);

      .advanced_search {
        display: flex;
        justify-content: center;
        padding: 20px 0;
        .carousel {
          padding: 10px 20px 20px 10px;
          border-radius: 10px;

          // height: 150px;
          background: none !important;
          /deep/ .el-carousel__button {
            width: 10px;
          }
          .el-carousel__item h3 {
            display: inline-block;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #475669;
            font-size: 14px;
            opacity: 0.75;

            margin: 0;
            span {
              display: inline-block;
            }
          }

          .el-carousel__item:nth-child(2n) {
            background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
            background-size: 100% 100%;
          }

          .el-carousel__item:nth-child(2n + 1) {
            background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
            background-size: 100% 100%;
          }
        }
        .el-tabs {
          width: 79%;
          .el-tab-pane {
            .el-popover {
            }
            .el-input {
              /deep/ .el-input__inner {
              }
            }
            .el-button {
              margin: 0;
              border: 0;
            }
          }
        }
        /deep/ .el-popover--plain {
          margin-left: 700px;
        }
      }
      .box_botton {
        display: flex;
        .box_left {
          width: 20%;
          max-width: 20%;
          padding: 0 10px 10px 0px;
          margin-right: 1%;

          border-radius: 5px;

          margin-bottom: 2%;
          /deep/ .el-menu {
            background: #faf1e8 !important;
            background-color: #faf1e8 !important;
            border: none;
            border-radius: 10px;
          }
          h2 {
            margin: 10px 0;

            font-weight: 600;
            span {
              font-size: 28px;
              color: chocolate;
              font-weight: 600;
            }
          }
        }
        .box_right {
          width: 80%;
          position: relative;
          top: -20px;

          .box_right_top {
            padding: 10px;

            border-radius: 5px;
            display: flex;
            justify-content: space-between;
            .el-select {
              width: 110px;
              height: 10px;
              color: violet !important;
            }
          }
          .types {
            .listPick {
              color: #ddb361;
              background: #faf1ea;
              border-color: #ddb361;
            }
            .EChart {
              background: none !important;
            }
            .el-button:hover {
              color: #ddb361;
              background: #faf1ea;
              border-color: #ddb361;
            }
          }
          .box_main {
            .box_main_list {
              margin: 10px 0 20px 0px;

              border-radius: 5px;
              padding: 10px;

              background: #fbf2eb;
              position: relative;
              .title {
                display: flex;
                justify-content: space-between;

                line-height: 28px;
                h2 {
                  width: 800px;
                  font-size: 16px;
                  font-weight: 600;
                }
              }
              .title :hover {
                color: #cf8700;
              }
              .case {
                background: #cf8700;
                color: white;

                margin: 5px;

                border-radius: 5px;
              }
              .box_detail {
                margin-top: 10px;

                background: #f0e1d5;
                padding: 18px;
                .basic {
                  margin-bottom: 30px;
                  font-size: 18px;
                  display: flex;

                  .basic_right {
                    width: 100%;
                    padding-left: 10px;
                    .basic_content {
                      width: 50%;
                      div {
                        line-height: 30px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                      }
                    }
                  }
                  .details {
                    width: 85%;
                    padding-left: 10px;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;

                    p {
                      line-height: 20px;
                    }
                  }
                }
                .card {
                  margin: 20px 0 0 0;
                  .mores {
                    display: flex;
                    justify-content: center;
                    span {
                      display: inline-block;
                      cursor: pointer;
                    }
                  }
                  p {
                    line-height: 20px;
                    overflow: hidden;
                    -webkit-line-clamp: 5;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                  }
                  .hits {
                    line-height: 30px;
                    display: flex;
                    span {
                      display: inline-block;
                    }
                  }
                  /deep/ .el-tabs__content {
                    background: #fbf2eb;
                  }
                  /deep/ .el-tabs__nav-scroll {
                    .el-tabs__item.is-active {
                      color: #ddb361;

                      background: #fbf2eb;
                      border-right-color: #dcdfe6;
                      border-left-color: #dcdfe6;
                    }
                  }
                  /deep/ .el-tabs__nav-wrap {
                    background: #f0e1d5;
                  }
                }

                .detail {
                }
              }
            }
          }
        }
      }
    }
  }
}
.conditions {
  display: flex;
  // height: 32px;
  line-height: 32px;
  justify-content: space-between;
  margin: 10px 0 0 0;
  .condition {
    position: relative;
    span {
      // display: block;
    }
    // overflow: hidden;
    .eltags {
      display: inline-block;
      // max-width: 610px;
      max-width: 810px;
      margin-left: 60px;
      display: flex;
      flex-wrap: wrap;
    }
    .el-tag {
      margin: 0 0 5px 5px;
    }
  }
  .savebtn :hover {
    color: #409eff;
    cursor: pointer;
  }
}
.box_botton {
  display: flex;
  .box_left {
    width: 20%;
    max-width: 20%;
    padding: 0 10px 10px 0px;
    margin-right: 1%;

    border-radius: 5px;
    // height: 100vh;
    // min-height: 1000px;
    // max-height: 3000px;
    // background: white;

    margin-bottom: 2%;
    /deep/ .el-menu {
      // background: white;
      background: #faf1e8 !important;
      background-color: #faf1e8 !important;
      border: none;
      border-radius: 10px;
    }
    h2 {
      margin: 10px 0;
      // font-size: 18px;
      font-weight: 600;
      span {
        font-size: 28px;
        color: chocolate;
        font-weight: 600;
      }
    }
  }
  .box_right {
    width: 80%;
    position: relative;
    top: -20px;
    // background: white;
    .box_right_top {
      padding: 10px;
      // background: white;
      // background-color: rgb(250, 242, 234);
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      .el-select {
        width: 110px;
        height: 10px;
        color: violet !important;
      }
    }
    .types {
      .listPick {
        // color: #409eff;
        // background: #ecf5ff;
        // border-color: #b3d8ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
        // border-radius: 4px;
      }
      .EChart {
        background: none !important;
      }
      .el-button:hover {
        // color: #409eff;
        // border-color: #c6e2ff;
        // background-color: #ecf5ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
    }
    .box_main {
      // margin-top: 20px;
      // box-sizing: none !important;
      .box_main_list {
        margin: 10px 0 20px 0px;
        // height: 200px;
        // height: 300px;
        border-radius: 5px;
        padding: 10px;
        // background: #f8f7f6;
        background: #fbf2eb;
        .title {
          display: flex;
          justify-content: space-between;
          // margin-bottom: 10px;
          line-height: 28px;
          h2 {
            width: 800px;
            font-size: 16px;
            font-weight: 600;
          }
          h2 :hover {
            // color: rgb(197, 197, 197);
            color: #cf8700;
            //  border-bottom:1px solid #cf8700;
          }
        }
        // .title :hover {
        //   // color: rgb(197, 197, 197);
        //   color: #cf8700;
        //   //  border-bottom:1px solid #cf8700;
        // }
        .case {
          background: #cf8700;
          color: white;
          // display: inline-block;
          margin: 5px;
          // padding: 5px;
          border-radius: 5px;
        }
        .box_detail {
          margin-top: 10px;
          // height: 200px;
          // background: #ffffff;

          background: #f0e1d5;
          padding: 18px;
          .basic {
            margin-bottom: 30px;
            font-size: 18px;
            display: flex;
            // align-items: center;
            .basic_left {
              width: 15%;
              // height: 56px;
              display: inline-block;
              padding: 20px 20px 10px 20px;
              border-right: 1px solid rgb(172, 112, 0);
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .basic_right {
              width: 85%;
              padding-left: 10px;
              .basic_content {
                width: 50%;
                div {
                  line-height: 30px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
            .details {
              width: 85%;
              padding-left: 10px;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;

              p {
                line-height: 20px;
              }
            }
          }
          .card {
            margin: 20px 0 0 0;
            .mores {
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                cursor: pointer;
              }
            }
            p {
              line-height: 20px;
              overflow: hidden;
              -webkit-line-clamp: 5;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }
            .hits {
              line-height: 30px;
              display: flex;
              span {
                display: inline-block;
              }
            }
            /deep/ .el-tabs__content {
              // background: #f0e1d5;
              background: #fbf2eb;
            }
            /deep/ .el-tabs__nav-scroll {
              .el-tabs__item.is-active {
                color: #ddb361;
                // background: #f0e1d5;
                background: #fbf2eb;
                border-right-color: #dcdfe6;
                border-left-color: #dcdfe6;
              }
            }
            /deep/ .el-tabs__nav-wrap {
              // background: #fbf2eb;
              background: #f0e1d5;
            }
          }

          .detail {
          }
        }
      }
    }
  }
}
.tit_input {
  /deep/ .el-input-group__append {
    border: none;
  }
  /deep/ .el-input-group__prepend {
    border: none;
  }
  /deep/ .el-input__inner {
    border: none;
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    // background: #fef7f0;
    background: #f7f1eb;
    border-right: #b7a974 1px solid;
    border-top: #b7a974 1px solid !important;
    border-bottom: #b7a974 1px solid;
    position: relative;
    top: 0px;
    height: 43px;
  }
}
.search_button {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
}
.titSelect {
  // background: #fef7f0;
  background: #f7f1eb;
  height: 43px;
  // border: none;
  border-left: #b7a974 1px solid;
  // border-top: #b7a974 1px solid !important;
  border-bottom: #b7a974 1px solid;
  border-start-start-radius: 4px;
  border-end-start-radius: 4px;
  border-end-end-radius: 0px;
  border-start-end-radius: 0px;
  /deep/ .el-input__inner {
    text-align: center;
    // border-radius: 0;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
  }
  /deep/ .el-input__suffix-inner {
    // display: inline-block;
    // border: none;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    padding: 0 15px;
    // margin-top: 5px;
    position: relative;
    top: 2px;
    border-right: 1px #e8e3dd solid;
    i {
      position: relative;
      top: -2px;
    }
  }
}
/deep/ .el-tree-node__expand-icon {
  position: relative;
  top: 3px;
}
.el-tree {
  background: #faf1e8;
}
.bac {
  /deep/ .el-input__inner {
    background: none;
  }
}
.sift_tree::-webkit-scrollbar {
  display: none;
}
.sift_tree {
  max-height: 450px;
  overflow-x: hidden;

  // overflow-y: scroll;
}
.el-menu {
  padding: 0 0 20px 0;
}
.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(247, 26, 26);
  color: rgb(156, 65, 53);
}
.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 10, 10);
  color: rgb(195, 64, 255);
}
.sift_tree {
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
  }
  /deep/ .el-tree-node__content:hover {
    /*设置鼠标飘过的颜色 */
    // background: #eaf9ff !important;
    color: #e6a23c;

    background: none !important;
    .custom-tree-node {
      span {
        // font-weight: 900 !important;
      }
    }
  }
  /deep/ .el-tree-node__label {
  }

  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    /*current选中的样式 */
    color: #e4b453;
    font-weight: bold;
    background: none !important;
    // background-color: #dde9ff !important;
  }
  /deep/ .custom-tree-node {
    // display: inline-block;
    padding-right: 10px;
  }
}
.more {
  cursor: pointer;
  color: #409eff;
  height: 30px;
  width: 100%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(250, 242, 234);
}
.collDown {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.collection {
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
.key_txt {
  display: inline-block;
  display: flex;
  .key_tit {
    min-width: 70px;
    display: inline-block;
  }
  .key_box {
    display: inline-block;
    margin: 5px 0 0 0;
    line-height: 20px;
  }
  span {
  }
}
.add_s {
  width: 100%;
  display: flex;
  margin: 0 0 10px 0;
  .el-button {
    padding: 0;
    margin: 0;
  }
}
/deep/ .el-icon-circle-plus {
  font-size: 28px !important;
  color: rgb(233, 191, 7);
}
/deep/ .el-icon-remove {
  font-size: 28px !important;
  color: rgb(233, 191, 7);
}

/deep/ .el-checkbox__original {
  width: 0 !important;
  height: 0 !important;
}
.box_left {
  /deep/ .el-submenu__title:hover {
    color: #e4b453;
    background: none !important;
  }
}
.word_tag {
  // word-break: normal;
  // width: auto;
  // display: block;
  // white-space: pre-wrap;
  // word-wrap: break-word;
  // overflow: hidden;
  // width: 90%;
  display: inline-block;
  // width: calc(100% - 50px);
  .el-tag {
    color: #fff;
    background-color: #e6a23c;
    border-color: #e6a23c;

    /deep/ .el-tag__close {
      color: #f7f7f7;
      //  background-color: #030303;
    }
    /deep/ .el-tag__close:hover {
      color: #e6a23c;
      background-color: #fdf6ec;
    }
  }
}
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
.collection_icon {
  position: absolute;
  top: 55px;
  right: 20px;
}
.list_tag {
  color: #fff !important;
  background-color: #e6a23c;
  border-color: #e6a23c;
  width: 55px;
  margin: 0 5px;
  text-align: center;
}
</style>